export default {
      id: "all-styles-usage",
      viewBox: "0 0 512 120",
      url: __webpack_public_path__ + "img/svg-sprite.svg#all-styles",
      toString: function () {
        return this.url;
      }
    }